import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { taskStatusFilterConfig } from '../../../configs/task-status-filter-config';

export const TaskStatusFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Status'
      config={taskStatusFilterConfig}
    />
  );
};
